import { AxiosInstance } from 'axios'

import { City, MapSettings } from '@/store/city/city.types'
import { FeatureToggles } from '@/store/toggle/toggle.types'

import { Requisites, VarioqubPayload, VarioqubAnswer } from './types'
import {
  HttpStatusCode,
  NotFoundError,
  ServerError,
  Success,
} from '@/api/results'

export function createCityModule({
  axios,
  sentry,
  city,
}: {
  axios: AxiosInstance
  sentry: any
  city: string
}) {
  return {
    async fetchCityInfo(currentCity: string) {
      try {
        const { data } = await axios.get(`${currentCity}/detail/`)

        return new Success(data)
      } catch (error) {
        switch (error?.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Город не найден')
          default:
            return new ServerError(error)
        }
      }
    },

    async fetchCityList() {
      try {
        const { data } = await axios.get<City[]>(`/cities/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(error)
        switch (error?.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Список городов не найден')
          default:
            return new ServerError(error)
        }
      }
    },

    async fetchAnalytics() {
      try {
        const { data } = await axios.get(`${city}/analytics/`)

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так. fetchAnalytics')
        }
      }
    },
    async fetchFeatureToggle() {
      try {
        const { data } = await axios.get<FeatureToggles>(`${city}/settings/`)

        return new Success(data)
      } catch (error) {
        sentry.captureException(`Не удалось получить featureToggles: ${error}`)

        return new ServerError('Что-то пошло не так. fetchFeatureToggle')
      }
    },

    async fetchMapSettings() {
      try {
        const { data } = await axios.get<MapSettings>(`${city}/map_settings/`)

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так. fetchMapSettings')
        }
      }
    },

    async fetchRequisites() {
      try {
        const { data } = await axios.get<Requisites>(`${city}/requisites/`)

        return new Success(data)
      } catch (error) {
        switch (error.response?.status) {
          case HttpStatusCode.NOT_FOUND:
            return new NotFoundError('Страница не найдена')
          default:
            sentry.captureException(error)
            return new ServerError('Что-то пошло не так')
        }
      }
    },

    async fetchVarioqub(payload: VarioqubPayload) {
      try {
        const { data } = await axios.get<VarioqubAnswer>(
          'https://uaas.yandex.ru/v1/exps',
          {
            params: payload,
            withCredentials: false,
          },
        )

        return new Success(data)
      } catch (error) {
        sentry.captureException(`Не удалось получить VarioqubAnswer: ${error}`)

        return new ServerError('Что-то пошло не так. fetchVarioqub')
      }
    },
  }
}
